import { useState } from 'react';

import { useToggleModal } from 'common/hooks/toggle-modal';

type OnErrorCallback = (error: string) => void;

export const useWishlistModal = (onErrorCallback?: OnErrorCallback) => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useToggleModal();
  const [errorCode, setErrorCode] = useState('');

  const onModalClose = () => {
    handleModalClose();
    setErrorCode('');
  };

  const onError = (error: string) => {
    setErrorCode(error);
    if (error) handleModalOpen();
    if (onErrorCallback) onErrorCallback(error);
  };

  return { isModalOpen, handleModalOpen, handleModalClose, errorCode, onModalClose, onError };
};
